module.exports = {"TXTWCL_Singles":{"id":"TXTWCL_Singles","defaultMessage":"Singles","ontario":"Straight Bets","track":"Singles"}}